import { render, staticRenderFns } from "./BookingsPrescriber.vue?vue&type=template&id=31e26edd&scoped=true&"
import script from "./BookingsPrescriber.vue?vue&type=script&lang=ts&"
export * from "./BookingsPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./BookingsPrescriber.vue?vue&type=style&index=0&id=31e26edd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e26edd",
  null
  
)

export default component.exports